module.exports = __webpack_public_path__ + "img/error-close.6d08228d.svg";